(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/util.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/util.js');
"use strict";


const hideFooter = () => {
  var _document$querySelect;
  return (_document$querySelect = document.querySelector('.page-footer')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add('hide-page-footer');
};
const showFooter = () => {
  var _document$querySelect2;
  return (_document$querySelect2 = document.querySelector('.page-footer')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.classList.remove('hide-page-footer');
};
const onPlay = (e, history, redirect) => {
  const isDesktop = svs.core.detect.formfactor.desktop();
  const {
    track,
    index = 0,
    name,
    playtype
  } = e.currentTarget.dataset;
  if (svs.tur.PauseCheck.isBlockedWithDialog()) {
    e.preventDefault();
    return false;
  }
  svs.components.analytics.trackEvent({
    category: 'E-instant',
    event: 'Click',
    action: 'Game Launch',
    opt_label: name,
    opt_value: playtype === 'demo' ? 0 : 1
  });
  isDesktop && svs.components.analytics.trackPromoClick({
    ID: track,
    name: track,
    position: index
  });
  redirect();
};
const checkLoggedIn = function () {
  let isDemo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let returnUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && !isDemo) {
    svs.components.customer_login.login({
      returnNewCustomer: true,
      returnUrl,
      extraParams: {
        product: 'Fler Lotter',
        weeks: 1,
        subscription: false,
        gift: false,
        branding: 'fler-lotter'
      }
    });
  } else {
    return true;
  }
};
const desktopTransition = tl => {
  const content = document.querySelector('.e-instant-game-info-text-content');
  const wrap = document.querySelector('.e-instant-game-info-container');
  tl.fromTo(wrap, 0.4, {
    y: 50,
    opacity: 0
  }, {
    y: 0,
    opacity: 1
  });
  tl.fromTo(content.children, {
    y: -10,
    opacity: 0
  }, {
    opacity: 1,
    y: 0,
    stagger: 0.05,
    duration: 0.2
  });
  tl.fromTo('.page-footer, .js-items-menu-wrapper', 0.1, {
    display: ''
  }, {
    display: 'none'
  });
  tl.resume();
};
const mobileTransition = (tl, clickedEl) => {
  const wrap = document.querySelector('.e-instant-game-info-container');
  const targetRect = clickedEl.getBoundingClientRect();
  const img = wrap.querySelector('.e-instant-game-info-img');
  const content = wrap.querySelector('.e-instant-game-info-text-content');
  const blurredImage = wrap.querySelector('.e-instant-game-info-bg');
  const close = wrap.querySelector('.e-instant-game-info-icon-close');
  tl.fromTo(img, 0.3, {
    y: targetRect.top - targetRect.height,
    x: targetRect.left - targetRect.width / 2,
    scale: 0.4,
    rotation: gsap.utils.random(-10, 10),
    opacity: 0
  }, {
    y: 0,
    x: 0,
    scale: 1,
    opacity: 1,
    rotation: 0,
    ease: 'quad.out'
  });
  tl.fromTo(wrap, {
    opacity: 0
  }, {
    opacity: 1,
    duration: 0.4
  });
  tl.fromTo(blurredImage, {
    opacity: 0
  }, {
    opacity: 1,
    duration: 0.4
  }, '-=0.3');
  tl.fromTo(content.children, {
    y: -10,
    opacity: 0
  }, {
    opacity: 1,
    y: 0,
    stagger: 0.05,
    duration: 0.2
  });
  tl.fromTo('.page-footer, .js-items-menu-wrapper', 0.1, {
    display: ''
  }, {
    display: 'none'
  });
  tl.fromTo(close, {
    opacity: 0
  }, {
    opacity: 1,
    duration: 0.2
  });
  tl.resume();
};
const loadImages = onLoadDone => {
  const images = Array.from(document.querySelector('.e-instant-game-info-container').querySelectorAll('img'));
  for (let i = 0; i < images.length; i++) {
    const img = images[i];
    img.addEventListener('load', () => {
      if (i === images.length - 1) {
        onLoadDone();
      }
    });
  }
};
const createAnimationTimeline = (onImagesLoaded, onHideAnimationDone, gameUrl) => {
  let tl = new gsap.timeline({
    paused: true,
    onStart: () => {
      var _document$querySelect3;
      (_document$querySelect3 = document.querySelector('html')) === null || _document$querySelect3 === void 0 || _document$querySelect3.classList.add('disable-body-scroll');
    },
    onReverseComplete: () => {
      var _document$querySelect4;
      (_document$querySelect4 = document.querySelector('html')) === null || _document$querySelect4 === void 0 || _document$querySelect4.classList.remove('disable-body-scroll');
      onHideAnimationDone();
    }
  });
  return {
    showInfo: () => {
      const onLoadDone = () => {
        onImagesLoaded();
        if (svs.core.detect.formfactor.mobile()) {
          var _Array$from;
          const clickedEl = (_Array$from = Array.from(document.querySelectorAll('.e-instant-lobby-game-link'))) === null || _Array$from === void 0 ? void 0 : _Array$from.find(el => (el === null || el === void 0 ? void 0 : el.getAttribute('data-url')) === gameUrl);
          tl && mobileTransition(tl, clickedEl);
        } else {
          tl && desktopTransition(tl);
        }
      };
      loadImages(onLoadDone);
    },
    hideInfo: () => {
      tl.reverse();
    },
    kill: () => {
      tl.kill();
      tl = null;
    }
  };
};
setGlobal('svs.eInstant.util', {
  hideFooter,
  showFooter,
  createAnimationTimeline,
  onPlay,
  checkLoggedIn
});

 })(window);